import { AbstractControl, ValidationErrors, ValidatorFn } from "@angular/forms";

export function maxDecimalPlacesValidator (maxDecimalPlaces: number): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    if (typeof control.value !== "string") {
      return null;
    }

    const numberStr = control.value as string,
     decimalSplit = numberStr.split(".");
    if (decimalSplit.length === 1) {
      return null;
    }
    const lastSplit = decimalSplit[decimalSplit.length - 1];
    if (lastSplit.length <= maxDecimalPlaces) {
      return null;
    }

    return { "maxDecimalPlaces": true };
  };
}
